import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import user from './modules/user';
import error from './modules/error';
import organization from './modules/organization';
import roleRequest from './modules/roleRequest';
import license from './modules/license';
import userRole from './modules/userRole';
import language from './modules/language';
import bestList from './modules/bestList';
import performance from './modules/performance';
import checking from './modules/checking';
import competition from './modules/competition';
import compApproval from './modules/compApproval';
import definitions from './modules/definitions';
import eventregistration from './modules/eventRegistration';
import records from './modules/records';
import manualbestlists from './modules/manualbestlists';

import root from './modules/root';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		auth,
		user,
		error,
		organization,
		roleRequest,
		license,
		userRole,
		language,
		bestList,
		performance,
		root,
		checking,
		competition,
		compApproval,
		definitions,
		eventregistration,
		records,
		manualbestlists,
	},
});
